(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const API_BASE_URL = 'https://famame.app';
    const sliderContainer = document.getElementById('homepage-review-slider-container');
    const loadingMessage = document.getElementById('homepage-reviews-loading');
    const errorMessage = document.getElementById('homepage-reviews-error');
    
    const googleIconSvg = `<svg class="review-source-icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path fill="#4285F4" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C12.955 4 4 12.955 4 24s8.955 20 20 20s20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/><path fill="#34A853" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C16.318 4 9.656 8.337 6.306 14.691z"/><path fill="#FBBC05" d="M24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44c5.986 0 11.182-2.155 14.899-5.727l-5.455-4.244C30.591 34.899 27.455 36 24 36z"/><path fill="#EA4335" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571l5.455 4.244C39.882 34.661 44 29.833 44 24c0-1.341-.138-2.65-.389-3.917z"/></svg>`;
    
    const generateStars = (rating) => {
      let starsHtml = '';
      const size = 20; // Use a consistent size for summary stars
      for (let i = 1; i <= 5; i++) {
        const fill = i <= Math.round(rating) ? '#ffc700' : '#d1d1d1';
        starsHtml += `<svg width="${size}" height="${size}" viewBox="0 0 24 24"><path fill="${fill}" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>`;
      }
      return starsHtml;
    };

    const buildReviewCardHtml = (review) => {
      const reviewDate = new Date(review.review_date).toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' });
      let sourceHtml = '';
      if (review.source_type && review.source_type.toLowerCase() === 'google') {
        sourceHtml = `<span class="review-source">${googleIconSvg} Google Review</span>`;
      } else {
        sourceHtml = `<span class="review-source">${review.source || 'famame-shop.de'}</span>`;
      }
      return `
        <div class="review-card">
          <div class="review-card-header">
            <div class="reviewer-info">
              <span class="reviewer-name">${review.reviewer_name}</span>
              ${sourceHtml}
            </div>
            <div class="star-rating">${generateStars(review.rating)}</div>
          </div>
          <h3 class="review-headline">${review.headline}</h3>
          <p class="review-body">${review.review_body.replace(/\n/g, '<br>')}</p>
          <div class="review-date">${reviewDate}</div>
        </div>
      `;
    };

    const fetchHomepageReviews = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/shop-reviews/general`);
        if (!response.ok) throw new Error(`API Error: ${response.status}`);
        
        const responseData = await response.json(); 
        const reviews = responseData.data.reviews;

        loadingMessage.style.display = 'none';
        if (!reviews || !Array.isArray(reviews) || reviews.length === 0) {
            sliderContainer.innerHTML = '<p style="text-align: center;">No testimonials available yet.</p>';
            return;
        }

        const reviewCount = reviews.length;
        const totalRating = reviews.reduce((acc, review) => acc + review.rating, 0);
        const averageRating = (totalRating / reviewCount).toFixed(1);

        document.getElementById('homepage-summary-rating-value').textContent = `${averageRating} out of 5`;
        document.getElementById('homepage-summary-star-rating').innerHTML = generateStars(averageRating);
        document.getElementById('homepage-summary-review-count').textContent = `Based on ${reviewCount} reviews`;
        document.querySelector('.custom-reviews-summary').style.display = 'flex';

        // --- FIX: Logic to handle single vs. multiple reviews ---
        if (reviews.length === 1) {
          // If only one review, display it as a single centered card without the slider
          sliderContainer.innerHTML = `<div class="single-review-wrapper">${buildReviewCardHtml(reviews[0])}</div>`;
        } else {
          // If more than one review, build and initialize the slider
          const slidesHtml = reviews.map(buildReviewCardHtml).map(card => `<div class="swiper-slide">${card}</div>`).join('');

          sliderContainer.innerHTML = `
            <div class="swiper homepage-swiper-container">
              <div class="swiper-wrapper">${slidesHtml}</div>
              <div class="swiper-pagination"></div>
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
          `;

          new Swiper('.homepage-swiper-container', {
              loop: true,
              slidesPerView: 1,
              spaceBetween: 30,
              pagination: { el: '.swiper-pagination', clickable: true },
              navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
              breakpoints: {
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }
          });
        }
      } catch (error) {
        console.error('Failed to load homepage reviews:', error);
        loadingMessage.style.display = 'none';
        errorMessage.textContent = 'Could not load testimonials at this time.';
        errorMessage.style.display = 'block';
      }
    };
    fetchHomepageReviews();
  });

  } catch(e) { console.error(e); }
})();
})();
